// mailto is allowed because GFM autolinks the email addresses Mo surfaces constantly. Doubles as
// DOMPurify's ALLOWED_URI_REGEXP, whose non-URI attribute values must pass it too.
export const SAFE_URI_REGEXP = /^(?:(?:https?|mailto):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i;

// Browsers strip these before resolving, so "java\nscript:" must not slip past.
const URI_NOISE = /[\s\0-\x1F]/g;

function hasSafeScheme(href) {
  return SAFE_URI_REGEXP.test(String(href).replace(URI_NOISE, ""));
}

function parseHref(href) {
  try {
    return new URL(href, window.location.origin);
  } catch {
    return null;
  }
}

// Null means render as plain text. Renderers outside the sanitizer have only this check.
export default function safeParsedHref(href) {
  return href && hasSafeScheme(href) ? parseHref(href) : null;
}

const HAS_SCHEME = /^[a-z][a-z0-9+.\-]*:/i;

// Narrower rule for "Add to Mo" context items, mirroring massimo_safe_context_url so a chip can't
// link before send and lose its URL after. Rejects backslashes since URI.parse raises on any.
export function recordNavigationHref(href) {
  const raw = String(href ?? "").trim();
  if (raw.includes("\\")) return null;

  const url = safeParsedHref(raw);
  if (!url) return null;

  if (HAS_SCHEME.test(raw)) {
    return (url.protocol === "http:" || url.protocol === "https:") && url.host ? url : null;
  }
  return raw.startsWith("/") && url.origin === window.location.origin ? url : null;
}
